<template>
  <b-row align-h="center" class="vh-100 text-center" align-v="center">
    <b-col sm="10" md="6" lg="5" xl="4">
      <p class="mb-2 display-4"><b-icon variant="danger" class="mr-2" icon="exclamation-circle-fill"></b-icon>Error</p>
      <p class="display-4">{{ error }}<p/>
      <b-button variant="outline-dark" :to="{name: 'UserTicketsPage'}">
        <font-awesome-icon :icon="['fas', 'home']"/>
        Tornar a l'inici
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
// @ is an alias to /src

export default {
  data () {
    const errors = {
      404: 'No hem pogut trobar la pàgina que buscaves',
      403: 'No tens permissos per accedir a aquesta pàgina',
      500: 'Error inesperat'
    }
    const error = this.isNullOrUndefined(errors[this.$route.params.code]) ? errors[404] : errors[this.$route.params.code]
    return {
      error: error
    }
  }
}
</script>
